import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	overflow: none;
`;

export const Content = styled.div`
	background-color: white;
	margin-top: 25px;
	padding: 70px 0 70px 200px;
`;

export const Title = styled.div`
	font-style: normal;
	font-weight: 400;
	font-size: 18px;
	line-height: 24px;
	color: ${tokens.color_gray_dark};
`;

export const ContentCards = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-row-gap: 10vh;
	padding: 100px 0;

	#card {
		border: none;
		border-radius: 12px;
	}
`;
